function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2929 0.29301L3.99992 6.58601L1.70692 4.29301C1.51832 4.11085 1.26571 4.01006 1.00352 4.01234C0.741321 4.01461 0.490508 4.11978 0.3051 4.30519C0.119692 4.4906 0.0145233 4.74141 0.0122448 5.00361C0.00996641 5.26581 0.110761 5.51841 0.292919 5.70701L3.29292 8.70701C3.48045 8.89448 3.73475 8.9998 3.99992 8.9998C4.26508 8.9998 4.51939 8.89448 4.70692 8.70701L11.7069 1.70701C11.8891 1.51841 11.9899 1.26581 11.9876 1.00361C11.9853 0.741412 11.8801 0.4906 11.6947 0.305192C11.5093 0.119784 11.2585 0.0146148 10.9963 0.0123364C10.7341 0.010058 10.4815 0.110852 10.2929 0.29301Z",
  fill: "#FF3C3C"
});

var SvgCheckbox = function SvgCheckbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/checkbox.0b550617.svg";
export { ForwardRef as ReactComponent };